/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiDashboard,
    ApiDashboardFromJSON,
    ApiDashboardToJSON,
} from '../models';

export interface AddDashboardRequest {
    apiDashboard: ApiDashboard;
}

export interface DeleteDashboardRequest {
    id: number;
}

export interface FindDashboardUrlRequest {
    dashboardId: number;
    extraProps?: Array<string>;
}

export interface UpdateDashboardRequest {
    apiDashboard: ApiDashboard;
}

/**
 * 
 */
export class DashboardApi extends runtime.BaseAPI {

    /**
     * Creates new dashboard
     */
    async addDashboardRaw(requestParameters: AddDashboardRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiDashboard>> {
        if (requestParameters.apiDashboard === null || requestParameters.apiDashboard === undefined) {
            throw new runtime.RequiredError('apiDashboard','Required parameter requestParameters.apiDashboard was null or undefined when calling addDashboard.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/dashboards`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiDashboardToJSON(requestParameters.apiDashboard),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiDashboardFromJSON(jsonValue));
    }

    /**
     * Creates new dashboard
     */
    async addDashboard(requestParameters: AddDashboardRequest, initOverrides?: RequestInit): Promise<ApiDashboard> {
        const response = await this.addDashboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes dashboard
     */
    async deleteDashboardRaw(requestParameters: DeleteDashboardRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiDashboard>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteDashboard.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/dasboards/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiDashboardFromJSON(jsonValue));
    }

    /**
     * Deletes dashboard
     */
    async deleteDashboard(requestParameters: DeleteDashboardRequest, initOverrides?: RequestInit): Promise<ApiDashboard> {
        const response = await this.deleteDashboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all dashboards
     */
    async findAllDashboardsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ApiDashboard>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/dashboards`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiDashboardFromJSON));
    }

    /**
     * Returns all dashboards
     */
    async findAllDashboards(initOverrides?: RequestInit): Promise<Array<ApiDashboard>> {
        const response = await this.findAllDashboardsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Finds dashboard URL
     */
    async findDashboardUrlRaw(requestParameters: FindDashboardUrlRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.dashboardId === null || requestParameters.dashboardId === undefined) {
            throw new runtime.RequiredError('dashboardId','Required parameter requestParameters.dashboardId was null or undefined when calling findDashboardUrl.');
        }

        const queryParameters: any = {};

        if (requestParameters.extraProps) {
            queryParameters['extraProps'] = requestParameters.extraProps;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/dasboards/{dashboardId}/url`.replace(`{${"dashboardId"}}`, encodeURIComponent(String(requestParameters.dashboardId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Finds dashboard URL
     */
    async findDashboardUrl(requestParameters: FindDashboardUrlRequest, initOverrides?: RequestInit): Promise<string> {
        const response = await this.findDashboardUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates dashboard
     */
    async updateDashboardRaw(requestParameters: UpdateDashboardRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiDashboard>> {
        if (requestParameters.apiDashboard === null || requestParameters.apiDashboard === undefined) {
            throw new runtime.RequiredError('apiDashboard','Required parameter requestParameters.apiDashboard was null or undefined when calling updateDashboard.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/dashboards`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApiDashboardToJSON(requestParameters.apiDashboard),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiDashboardFromJSON(jsonValue));
    }

    /**
     * Updates dashboard
     */
    async updateDashboard(requestParameters: UpdateDashboardRequest, initOverrides?: RequestInit): Promise<ApiDashboard> {
        const response = await this.updateDashboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
